import Agreement from "@/views/agreement/index.vue";
import { Checkbox } from "view-design";
export default {
  components: {
    Agreement,
    Checkbox
  },
  name: "Agreenment",
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onClickAgreement(type) {
      this.$refs["Agreement"].open(type);
    },
    onChange(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
};